(() => {
  const isSetsPlp = () => Boolean(document.querySelector('[data-sets-plp]'));

  const normalizeColorValue = (value) => {
    if (!value) return '';
    return value
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ');
  };

  const getActiveFilterColors = () => {
    const colors = new Set();

    document
      .querySelectorAll('input[name*="filter.v.t.shopify.color-pattern"]:checked')
      .forEach((input) => {
        const forId = input.getAttribute('id');
        if (!forId) return;

        const label = document.querySelector(`label[for="${CSS.escape(forId)}"]`);
        if (!label) return;

        const tooltip = label.getAttribute('data-tooltip');
        const labelText = tooltip || label.textContent;
        const normalized = normalizeColorValue(labelText);
        if (normalized) colors.add(normalized);
      });

    return colors;
  };

  const getSetsSwatchContext = (target) => {
    // Synthetic events (bots, in-app browsers) can target document or a text node, which have no closest().
    if (!(target instanceof Element)) return null;

    const swatch = target.closest('.product-card__colors-link');
    if (!swatch) return null;

    const setsRoot = document.querySelector('[data-sets-plp]');
    if (!setsRoot || !setsRoot.contains(swatch)) return null;

    const card = swatch.closest('product-card') || swatch.closest('.product-card');
    if (!card) return null;

    return { swatch, card };
  };

  const applySwatchState = (card, swatch, { fromFilter = false } = {}) => {
    if (!card || !swatch) return;

    const siblings = card.querySelectorAll('.product-card__colors-link');
    siblings.forEach((item) => {
      item.classList.remove('js-color-active');
      item.classList.remove('js-color-hover');
      item.classList.remove('product-card__colors-link--active');
    });
    swatch.classList.add('js-color-active');
    swatch.classList.add('product-card__colors-link--active');

    const mainImage = card.querySelector('.js-main-product-image');
    const secondImage = card.querySelector('.product-card__image--secondary');
    const imageLink = card.querySelector('.js-product-card-image-link');
    const titleElement = card.querySelector('.product-card__title');
    const quickBuy = card.querySelector('.product-card__quick-buy');

    const hoverImageUrl = swatch.getAttribute('data-hover-image');
    const hoverSecondImageUrl = swatch.getAttribute('data-hover-second-image');
    const targetUrl = swatch.getAttribute('href');
    const priceHtml = swatch.getAttribute('data-price-html');
    const newTitle = swatch.getAttribute('data-title');
    const badgesHtml = swatch.getAttribute('data-badges-html');
    const isPreorder = swatch.getAttribute('data-is-preorder') === 'true';

    if (mainImage && hoverImageUrl) {
      mainImage.setAttribute('src', hoverImageUrl);
      mainImage.removeAttribute('srcset');
    }

    if (secondImage && hoverSecondImageUrl) {
      secondImage.setAttribute('src', hoverSecondImageUrl);
      secondImage.removeAttribute('srcset');
    }

    if (imageLink && targetUrl) {
      imageLink.setAttribute('href', targetUrl);
      imageLink.setAttribute('data-force-url', targetUrl);
    }

    if (priceHtml) {
      const priceContainer = card.querySelector('price-list');
      if (priceContainer) priceContainer.outerHTML = priceHtml;
    }

    if (badgesHtml !== null && badgesHtml !== '') {
      const badgeWrapper = card.querySelector('.product-card__badge-list-wrapper');
      if (badgeWrapper) badgeWrapper.innerHTML = badgesHtml;
    }

    if (titleElement && newTitle && !card.hasAttribute('data-lock-title')) {
      titleElement.textContent = newTitle;
    }

    if (quickBuy) quickBuy.style.display = isPreorder ? 'none' : '';

    if (typeof window.syncQuickBuyDrawerFromSwatch === 'function') {
      window.syncQuickBuyDrawerFromSwatch(card, swatch);
    }

    if (fromFilter) {
      card.removeAttribute('data-swatch-clicked');
    }
  };

  const applyFilteredColorSelection = () => {
    const activeFilterColors = getActiveFilterColors();
    if (!activeFilterColors.size) return;

    const productList = document.querySelector('[data-sets-plp]');
    if (!productList) return;

    productList.querySelectorAll('[data-custom-color-swatches]').forEach((wrapper) => {
      const card = wrapper.closest('product-card') || wrapper.closest('.product-card');
      if (!card) return;

      const swatches = card.querySelectorAll('.product-card__colors-link');
      let matchedSwatch = null;

      swatches.forEach((swatch) => {
        if (matchedSwatch) return;
        const swatchColor = normalizeColorValue(swatch.getAttribute('title'));
        if (swatchColor && activeFilterColors.has(swatchColor)) {
          matchedSwatch = swatch;
        }
      });

      if (matchedSwatch) applySwatchState(card, matchedSwatch, { fromFilter: true });
    });
  };

  const reinitSetsPlp = () => {
    if (typeof window.initColorSwatches === 'function') {
      window.initColorSwatches();
    }
    applyFilteredColorSelection();
  };

  const runAfterFacetReload = () => {
    const section = document.querySelector('.shopify-section--main-collection');
    if (!section) {
      reinitSetsPlp();
      return;
    }

    const checkInterval = setInterval(() => {
      if (!section.classList.contains('is-loading')) {
        clearInterval(checkInterval);
        requestAnimationFrame(reinitSetsPlp);
      }
    }, 50);
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!isSetsPlp()) return;

      const context = getSetsSwatchContext(event.target);
      if (!context) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      context.card.setAttribute('data-swatch-clicked', 'true');
      applySwatchState(context.card, context.swatch);
    },
    true
  );

  document.addEventListener('mouseover', (event) => {
    if (!isSetsPlp() || window.matchMedia('(pointer: coarse)').matches) return;

    const context = getSetsSwatchContext(event.target);
    if (!context || context.card.hasAttribute('data-swatch-clicked')) return;

    applySwatchState(context.card, context.swatch);
  });

  document.addEventListener('mouseout', (event) => {
    if (!isSetsPlp() || window.matchMedia('(pointer: coarse)').matches) return;
    if (!(event.target instanceof Element)) return;

    const wrapper = event.target.closest('.product-card__colors-wrapper');
    if (!wrapper || wrapper.contains(event.relatedTarget)) return;

    const card = wrapper.closest('product-card') || wrapper.closest('.product-card');
    if (!card || card.hasAttribute('data-swatch-clicked')) return;

    const activeSwatch =
      card.querySelector('.product-card__colors-link--active') ||
      card.querySelector('.js-color-active');
    if (activeSwatch) applySwatchState(card, activeSwatch);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reinitSetsPlp);
  } else {
    reinitSetsPlp();
  }

  document.addEventListener('facet:update', runAfterFacetReload);
})();
